import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const LOGO =
  "https://customer-assets.emergentagent.com/job_ea29b796-903f-4580-bdca-2f501b22a9b8/artifacts/62l7s6as_Lex%20Balance%20Perfecto.png";

const links = [
  { id: "nosotros", label: "Nosotros" },
  { id: "principios", label: "Distintivos" },
  { id: "servicios", label: "Servicios" },
  { id: "diferenciadores", label: "Clientes" },
  { id: "contacto", label: "Contacto" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState("");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const sections = links.map((l) => document.getElementById(l.id)).filter(Boolean);
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) setActive(e.target.id);
        });
      },
      { rootMargin: "-40% 0px -55% 0px", threshold: 0 }
    );
    sections.forEach((s) => io.observe(s));
    return () => io.disconnect();
  }, []);

  const go = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-white/50 backdrop-blur-xl border-b border-[#17351D]/8"
          : "bg-white/50 backdrop-blur-xl"
      }`}
    >
      <div className="max-w-[1440px] mx-auto pr-6 md:pr-10 flex items-stretch justify-between h-[88px] md:h-[100px]">
        <button
          data-testid="logo-home-btn"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center px-5 md:px-7 transition-colors"
          aria-label="Lex Balance Perfecto - Inicio"
        >
          <img
            src={LOGO}
            alt="Lex Balance Perfecto"
            className="h-14 md:h-[72px] w-auto object-contain"
          />
        </button>

        <div className="flex items-center gap-6 md:gap-10">
          <nav className="hidden lg:flex items-center gap-10">
            {links.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-${l.id}-link`}
                onClick={() => go(l.id)}
                className={`nav-link text-[13px] tracking-[0.18em] uppercase text-[#17351D]/75 hover:text-[#17351D] ${
                  active === l.id ? "active text-[#17351D]" : ""
                }`}
              >
                {l.label}
              </button>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <button
              data-testid="nav-cta-contact"
              onClick={() => go("contacto")}
              className="hidden md:inline-flex btn-primary bg-[#C1C82A] text-[#17351D] font-semibold text-[12px] tracking-[0.22em] uppercase px-6 py-3"
            >
              Agenda una cita
            </button>
            <button
              data-testid="nav-mobile-toggle"
              className="lg:hidden text-[#17351D] p-2"
              onClick={() => setOpen((v) => !v)}
              aria-label="Menú"
            >
              {open ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile drawer */}
      <div
        className={`lg:hidden overflow-hidden transition-[max-height] duration-500 ease-out bg-[#17351D] border-t border-white/5 ${
          open ? "max-h-[480px]" : "max-h-0"
        }`}
      >
        <nav className="flex flex-col px-6 py-6 gap-4">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`mobile-nav-${l.id}`}
              onClick={() => go(l.id)}
              className="text-left text-white text-base tracking-[0.18em] uppercase py-2 border-b border-white/5"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="mobile-cta-contact"
            onClick={() => go("contacto")}
            className="btn-primary bg-[#C1C82A] text-[#17351D] font-semibold text-xs tracking-[0.22em] uppercase px-6 py-4 mt-3"
          >
            Agenda una cita
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
